// extracted by mini-css-extract-plugin
module.exports = {"coming-soon-wrapper":"ComingSoon_coming-soon-wrapper__yxCxC","coming-soon-card":"ComingSoon_coming-soon-card__zvDH0"};